import PropTypes from 'prop-types';
import React from 'react';

import Container from '@glass/web/components/Layout/Container';

import ConsumerLayoutPage from '@glass/shared/components/Layout/ConsumerLayoutPage';
import { DISABLE_LOADING, SSR_LOADING } from '@glass/shared/components/Section/loadingMethods';
import useRequireAuth from '@glass/shared/modules/auth/useRequireAuth';

const footerProps = {
  resourceSectionLoadingMethod: DISABLE_LOADING,
  supportSectionLoadingMethod: SSR_LOADING,
  isSupportPhone: true,
};
const headerProps = {
  transparent: false,
  addFixedHeaderSpacing: true,
};

function ProfileLayoutPage({ children, pageTitle }) {
  useRequireAuth();

  return (
    <ConsumerLayoutPage footerProps={footerProps} headerProps={headerProps} pageTitle={pageTitle}>
      <Container isFullPage>{children}</Container>
    </ConsumerLayoutPage>
  );
}

ProfileLayoutPage.propTypes = {
  children: PropTypes.node,
  pageTitle: PropTypes.string,
};

export default ProfileLayoutPage;
